import IsMacService from "@core-ui/ContextServices/IsMac";
import PageDataContext from "@core-ui/ContextServices/PageDataContext";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import PermissionService from "@ext/security/logic/Permission/components/PermissionService";
import { configureWorkspacePermission } from "@ext/security/logic/Permission/Permissions";
import { type Feature, getFeatureList } from "@ext/toggleFeatures/features";

export type FeatureVisibilityContext = {
	isMac: boolean;
	isTauri: boolean;
	isNext: boolean;
	isRelease: boolean;
	canConfigure: boolean;
};

/**
 * The single answer to "which experimental features does this user actually see".
 * Both the feature list itself and the settings tab that hosts it read it, so an
 * empty result hides the tab instead of showing an empty section.
 */
export const visibleFeatures = (features: Feature[], context: FeatureVisibilityContext): Feature[] => {
	if (context.isNext && !context.canConfigure) return [];

	return features.filter((feature) => {
		// temp, waiting for fix in mac desktop
		if (context.isMac && context.isTauri && feature.name === "cloud") return false;
		if (feature.status === "in-dev" && context.isRelease) return false;
		return true;
	});
};

export const useVisibleFeatures = (): Feature[] => {
	const isRelease = PageDataContext.value.conf.isRelease;
	const { isTauri, isNext } = usePlatform();
	const isMac = IsMacService.value;
	const canConfigure = PermissionService.useCheckPermission(configureWorkspacePermission);

	return visibleFeatures(getFeatureList(), { isMac, isTauri, isNext, isRelease, canConfigure });
};
